import { render, staticRenderFns } from "./NavTile.vue?vue&type=template&id=38512715&scoped=true&"
import script from "./NavTile.vue?vue&type=script&lang=js&"
export * from "./NavTile.vue?vue&type=script&lang=js&"
import style0 from "./NavTile.vue?vue&type=style&index=0&id=38512715&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38512715",
  null
  
)

export default component.exports